
import { defineComponent, ref, reactive, toRefs, onMounted, computed, nextTick, watch } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import api from '@/api/allApi'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
export default defineComponent({
  components: { Table, Nodata },
  props: {
    itemdata: {
      type: Object,
      default: function() {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  setup(props: any, context) {
    const pageData: any = reactive({
      data: [],
      columns: [],
      spinning: true
    })
    pageData.columns = [
      {
        title: '变动日期',
        dataIndex: 'ChangeTD',
        key: 'ChangeTD',
        width: '100px'
      },
      {
        title: '变动人',
        dataIndex: 'StockHolder',
        key: 'StockHolder',
        width: '120px',
        ellipsis: true,
        slots: { customRender: 'ellipsis' }
      },
      {
        title: '变动数量(股)',
        dataIndex: 'StockSumChanging',
        key: 'StockSumChanging',
        width: '105px',
        slots: { customRender: 'peopleCountColor' }
      },
      {
        title: '交易均价(元)',
        dataIndex: 'AvgPrice',
        key: 'AvgPrice',
        width: '105px',
        slots: { customRender: 'decimal' }
      },
      {
        title: '结存股票(股)',
        dataIndex: 'HoldSumAfterAlter',
        key: 'HoldSumAfterAlter',
        width: '105px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '交易方式',
        dataIndex: 'Direction',
        key: 'Direction',
        ellipsis: true,
        width: '110px',
        slots: { customRender: 'ellipsis' }
      },
      {
        title: '董监高管',
        dataIndex: 'LeaderName',
        key: 'LeaderName',
        width: '100px',
        ellipsis: true,
        slots: { customRender: 'ellipsis' }
      },
      {
        title: '高管职位',
        dataIndex: 'PositionDesc',
        key: 'PositionDesc',
        width: '150px',
        ellipsis: true,
        slots: { customRender: 'ellipsis' }
      },
      {
        title: '与高管关系',
        dataIndex: 'ConnectionDesc',
        key: 'ConnectionDesc',
        width: '100px',
        ellipsis: true,
        slots: { customRender: 'ellipsis' }
      }
    ]
    watch(
      () => (props.pageSourceData || {}).LeaderHoldChange || [],
      () => {
        const _data = (props.pageSourceData || {}).LeaderHoldChange || []
        let list = []
        if (_data.length) {
          list = JSON.parse(JSON.stringify(_data))
          list.forEach((item: any, i: number) => {
            item.index = 'LeaderHoldChange' + i
            item.ChangeTD = item.ChangeT ? window.moment(item.ChangeT * 1000).format('YYYY-MM-DD') : '—'
          })
        }
        nextTick(() => {
          pageData.spinning = false
        })
        pageData.data = list
      },
      { deep: true }
    )
    return {
      ...toRefs(pageData)
    }
  }
})
